import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import DataTable from 'react-data-table-component'
import apiService from 'apiService'
import DisableUserIcon from 'components/TableIcons/DisableUserIcon'
import EnableUserIcon from 'components/TableIcons/EnableUserIcon'
import DeleteUserIcon from 'components/TableIcons/DeleteUserIcon'

// components

export default function UsersTable() {
    const [users, setUsers] = useState([])
    const [update, setUpdate] = useState(0)
    const columns = [
        {
            name: 'ID',
            selector: row => row.id
        },
        {
            name: 'Όνομα Χρήστη',
            selector: row => row.username
        },
        {
            name: 'Ρόλος',
            selector: row => row.description.toUpperCase(),
            style: {
                fontWeight: 'bold'
            },
            conditionalCellStyles: [
                {
                    when: row => row.role_id === 1,
                    style: {
                        color: '#6495ED'
                    }
                },
                {
                    when: row => row.role_id === 2,
                    style: {
                        color: '#00008B'
                    }
                }
            ]
        },
        {
            name: 'Κατάσταση',
            selector: row => (row.enabled === 1 ? 'ΕΝΕΡΓΟΣ' : 'ΑΝΕΝΕΡΓΟΣ'),
            style: {
                fontWeight: 'bold'
            },
            conditionalCellStyles: [
                {
                    when: row => row.enabled === 1,
                    style: {
                        color: 'green'
                    }
                },
                {
                    when: row => row.enabled !== 1,
                    style: {
                        color: 'red'
                    }
                }
            ]
        },
        {
            name: 'Ενέργειες',
            cell: row => (
                <>
                    {row.enabled === 1 ? <DisableUserIcon userId={row.id} refreshTable={setUpdate} /> : <EnableUserIcon userId={row.id} refreshTable={setUpdate} />}
                    <DeleteUserIcon userId={row.id} refreshTable={setUpdate} />
                </>
            )
        }
    ]

    const getUsers = async () => {
        const result = await apiService.get(`/users`)
        setUsers(result)
    }

    useEffect(() => {
        getUsers()
    }, [update])

    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
                <div className="rounded-t mb-0 px-4 py-3 border-0">
                    <div className="flex flex-wrap items-center">
                        <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                            <h3 className={'font-semibold text-lg light'}>Πίνακας Χρηστών</h3>
                        </div>
                    </div>
                </div>
                <DataTable columns={columns} data={users} />
            </div>
        </>
    )
}

UsersTable.defaultProps = {
    color: 'light'
}

UsersTable.propTypes = {
    color: PropTypes.oneOf(['light', 'dark'])
}
